/* ==========================================================================
   VX LANDING · Interacciones (pestañas, selección de paquete, botón fijo)
   Se carga una sola vez aunque varias secciones lo incluyan.
   ========================================================================== */
(function () {
  if (window.__vxLandingInit) return;
  window.__vxLandingInit = true;

  /* ---- Pestañas ----
     Contenedor:  [data-vx-tabs]
     Botón:       [data-vx-tab="clave"]
     Contenido:   [data-vx-panel="clave"]  (usa "todas" para mostrar siempre) */
  function selectTab(btn) {
    var root = btn.closest('[data-vx-tabs]');
    if (!root) return;
    var key = btn.getAttribute('data-vx-tab');
    root.querySelectorAll('[data-vx-tab]').forEach(function (b) {
      b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      b.setAttribute('tabindex', b === btn ? '0' : '-1');
    });
    root.querySelectorAll('[data-vx-panel]').forEach(function (p) {
      var keys = (p.getAttribute('data-vx-panel') || '').split('|');
      var show = keys.indexOf(key) !== -1 || keys.indexOf('todas') !== -1;
      if (show) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vx-tab]');
    if (btn) selectTab(btn);
  });
  document.addEventListener('keydown', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vx-tab]');
    if (!btn || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var list = Array.prototype.slice.call(btn.parentNode.querySelectorAll('[data-vx-tab]'));
    var i = list.indexOf(btn) + (e.key === 'ArrowRight' ? 1 : -1);
    var next = list[(i + list.length) % list.length];
    next.focus();
    selectTab(next);
  });

  /* ---- Paquetes: actualiza el texto del botón según el paquete elegido ---- */
  function syncPack(form) {
    var checked = form.querySelector('input[name="id"]:checked');
    var btnLabel = form.querySelector('[data-vx-buy-label]');
    if (checked && btnLabel && checked.getAttribute('data-label')) {
      btnLabel.textContent = checked.getAttribute('data-label');
    }
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-vx-offer] input[name="id"]')) {
      syncPack(e.target.closest('[data-vx-offer]'));
    }
  });

  /* ---- Botón fijo en móvil: aparece al pasar el hero y se oculta en la oferta ---- */
  function initSticky() {
    var bar = document.querySelector('[data-vx-sticky]');
    if (!bar || bar.__vxReady) return;
    bar.__vxReady = true;
    var hero = document.querySelector('[data-vx-hero]');
    var offer = document.getElementById('vx-oferta');
    var pastHero = !hero, inOffer = false;
    function update() { bar.classList.toggle('is-visible', pastHero && !inOffer); }
    if (!('IntersectionObserver' in window)) { pastHero = true; update(); return; }
    if (hero) new IntersectionObserver(function (en) { pastHero = !en[0].isIntersecting; update(); }).observe(hero);
    if (offer) new IntersectionObserver(function (en) { inOffer = en[0].isIntersecting; update(); }, { threshold: 0.15 }).observe(offer);
  }

  function initAll() {
    document.querySelectorAll('[data-vx-offer]').forEach(syncPack);
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
